import { useCallback, useState } from "react";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";

import CoursesService from "../../service/coursesService";
import { getErrorMessage } from "../../../common/utils/error";

const coursesService = new CoursesService();
const useJoinCourse = (enrollUrl: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();

  const [disableButton, setDisableButton] = useState(false);

  const handleJoinCourse = useCallback(() => {
    setDisableButton(true);
    coursesService
      .enroll(enrollUrl, {})
      .then((res) => {
        if (res) {
          router.replace(router.asPath);
          enqueueSnackbar("You have successfully joined the course", {
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(getErrorMessage(err.response.data), {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        });
      })
      .finally(() => {
        setDisableButton(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enrollUrl]);

  return { disableButton, handleJoinCourse };
};

export default useJoinCourse;
